import { Drawer } from "@mui/material";
import PropTypes from "prop-types";

export default function ShowAssignedPIPMDrawer({ open, toggleDrawer, children }) {
  return (
    <Drawer 
      anchor='right' 
      sx={{ 
        zIndex: 1300,
        '& .MuiDrawer-paperAnchorRight': { 
          maxWidth: "100%",
          width: "25rem" // Optional: set a specific width if needed
        } 
      }} 
      onClose={toggleDrawer} 
      open={open}
    >
      {children}
    </Drawer>
  );
}

ShowAssignedPIPMDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  children: PropTypes.node
};